export default class LoadController {
	constructor() {
		this.didAsk = false;
		this.data = null;
		this.failed = false;
	}

	// COMPUTED PROPERTIES

	hasNotAsked() {
		return !this.didAsk;
	}

	isLoading() {
		return !this.data && !this.failed && this.didAsk;
	}

	hasFailed() {
		return this.failed;
	}

	hasData() {
		return this.data != null;
	}

	// STATE CHANGES

	clear() {
		this.data = null;
	}
}
